import * as MUI from '@mui/material';
import { useNavigate } from 'react-router-dom';

import LanguageIcon from '@mui/icons-material/Language';
import LiveTvIcon from '@mui/icons-material/LiveTv';
import CallIcon from '@mui/icons-material/Call';
import SmartphoneIcon from '@mui/icons-material/Smartphone';
import MiscellaneousServicesIcon from '@mui/icons-material/MiscellaneousServices';
import AddIcon from '@mui/icons-material/AddBox';

import TarifCounters from './TarifCounters';

// Список скрытых подписок
const hiddenIds = JSON.parse(localStorage.getItem('lk-hidden') || '[]');

function formatDateTime(datetime) {
    const re = /(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})/;
    const m = re.exec(datetime);
    if (m === null) {
        return datetime;
    }

    return m[3]+'.'+m[2]+'.'+m[1]+' '+m[4]+':'+m[5];
}

function servicePriceString(service) {
    if (service.pay_amount === 0) {
        return "Включено в тариф";
    }

    var price = service.pay_amount + " ₽";

    if (service.pay_period_unit === "day") {
        if (service.pay_period_length > 1) {
            price += " за " + service.pay_period_length + " дн";
        } else {
            price += " в день";
        }
    }
    if (service.pay_period_unit === "month") {
        if (service.pay_period_length > 1) {
            price += " за " + service.pay_period_length + " мес";
        } else {
            price += " в месяц";
        }
    }

    if (service.pay_next_time) {
        price += ", следующее списание " + formatDateTime(service.pay_next_time);
    }

    return price;
}

// Компонент для отображения списка подписок
const SubscriptionList = ({ subscriptions }) => {
    const navigate = useNavigate();

    if (!subscriptions || subscriptions.length === 0) return null;

    // Иконки для разных типов групп
    const groupIcons = {
        'internet': <LanguageIcon />,
        'tv': <LiveTvIcon />,
        'phone': <CallIcon />,
        'mobile': <SmartphoneIcon />,
        'other': <MiscellaneousServicesIcon />
    };
    
    return (
        <MUI.Box>
            {subscriptions.filter((sub) => hiddenIds.indexOf(sub.id) < 0).map((subscription) => (
                <MUI.Box key={subscription.id} sx={{ mb: 4 }}>

                    <MUI.Box display="flex" alignItems="center" justifyContent="space-between" sx={{ mb: 3 }}>
                        <MUI.Box>
                            <MUI.Typography variant="h5" sx={{ fontWeight: 'bold', mb: 0.5, color: 'text.primary' }}>
                                {subscription.name}
                                {subscription.blocked ?
                                    (<MUI.Chip label="Заблокировано" color="error" size="small" variant="outlined" sx={{ ml: 1, verticalAlign: 'top' }} />) :
                                    (<MUI.Chip label="Активно" color="success" size="small" variant="outlined" sx={{ ml: 1, verticalAlign: 'top' }} />)
                                }
                            </MUI.Typography>
                            <MUI.Typography variant="body2" color="text.secondary">
                                Тариф: {subscription.tarif_name}
                            </MUI.Typography>
                            {subscription.address && (<MUI.Typography variant="body2" color="text.secondary">
                                Адрес: {subscription.address}
                            </MUI.Typography>)}
                        </MUI.Box>
                        <MUI.Tooltip title="Управление услугами">
                            <MUI.IconButton sx={{ color: 'text.secondary' }} onClick={() => navigate('/services/'+subscription.id)}>
                                <AddIcon />
                            </MUI.IconButton>
                        </MUI.Tooltip>
                    </MUI.Box>

                    {/* Группы услуг */}
                    {subscription.groups.map((group) => (
                        <MUI.Box key={group.group_id} display="flex" sx={{ mb: 2 }}>
                            <MUI.Avatar sx={{ bgcolor: 'secondary', mr: 2, width: 32, height: 32 }}>
                                {groupIcons[group.type] || groupIcons['other']}
                            </MUI.Avatar>

                            <MUI.Grid container spacing={2} sx={{ flex: 1 }}>

                            <MUI.Grid item xs={12} xl={6}>
                                <MUI.Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: 'text.primary' }}>
                                    {group.description}
                                </MUI.Typography>
                                {/* Список идентификаторов группы */}
                                <MUI.Typography variant="body2" sx={{ fontWeight: 'medium', mb: 1 }}>
                                    {group.idents && group.idents.map((ident, index) => (<>
                                        {index ? ', ' : ''}
                                        <MUI.Typography component="span" sx={{ fontWeight: 'medium', color: 'info.main' }}>{ident}</MUI.Typography>
                                    </>))} &nbsp;
                                </MUI.Typography>

                                {/* Услуги в группе */}
                                {subscription.services.filter((srv) => srv.group_id === group.group_id).map((service) => (
                                    <MUI.Box key={service.id} sx={{ mb: 1 }}>
                                        <MUI.Typography variant="body2" color="text.primary">
                                            {service.name}
                                        </MUI.Typography>
                                        <MUI.Typography variant="body2" color="text.secondary">
                                            {servicePriceString(service)}
                                        </MUI.Typography>
                                    </MUI.Box>
                                ))}
                            </MUI.Grid>

                            {/* Счетчики в группе */}
                            <MUI.Grid item xs={12} xl={6}>
                                {subscription.tarif_counters &&
                                    (<TarifCounters counters={subscription.tarif_counters.filter((counter) => counter.group_id === group.group_id)} />)
                                }
                            </MUI.Grid>
                            
                            </MUI.Grid>
                        </MUI.Box>
                    ))}
                </MUI.Box>
            ))}
        </MUI.Box>
    );
};

export default SubscriptionList;
